import React, { useEffect, useState, useRef } from 'react';
import { Input, Popover } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons';
import { CaretDownFilled } from '@ant-design/icons';
import { useLazyQuery } from '@apollo/client';
import { getCustomerQuery } from "@src/util/query/customer.query";




export const TaskFilter = ({group, setGroup, groupList, setSelectedCustomer, selectedCustomer=null, isLegacyTenant=false, searchText="", setSearchText=()=>{}})=>{
   
 

    const popoverRef = useRef(null);
    const inputRef = useRef(null);


    const [groupSearch, setGroupSearch] = useState();
    const [groupPopover, setGroupPopover] = useState(false);
    const [localGroup, setLocalGroup] = useState(groupList);

    useEffect(()=>{
        setLocalGroup(groupList);
    },[groupList]);
    

    
    const [customerSearch, setCustomerSearch] = useState("");
    const [customerPopover, setCustomerPopover] = useState(false);

  

    useEffect(()=>{
        if(groupPopover){
            setGroupPopover(true);
            setCustomerPopover(false);
        }
        else{
            setGroupPopover(false)
        }
        setGroupSearch('');
    },[groupPopover])

    useEffect(()=>{
        if(customerPopover){
            setCustomerPopover(true);
            setGroupPopover(false);
        }
        else{
            setCustomerPopover(false)
        }
        setCustomerSearch('');
    },[customerPopover])



    const [getCustomer,{data: customerData, loading: customerLoading, refetch}] = useLazyQuery(getCustomerQuery);

    useEffect(()=>{
        if(customerSearch?.length>0){
            getCustomer(
                {
                    fetchPolicy: 'cache-and-network',
                    variables: {
                        input: {
                            filters: null,
                            pageSize: 5,
                            page: 1,
                            search: customerSearch
                        }
                    }
                }
            );
        }
    },[customerSearch]);


    return(
        <div className="filter"  style={{margin:0}}>
            <div className="filter-inner">

                <div className='left-filter-inner'>
                    {/* <div style={{width: 'max-content'}}>Filter by:</div> */}

                    {!isLegacyTenant &&
                    <div  style={{ width:'280px'}}>
                        <Input
                            type="search"
                            className='generic-input-control'
                            placeholder="Search by task or site name..."
                            value={searchText}
                            onChange={(e)=>setSearchText(e.target.value)}
                            autoComplete="off"
                            suffix={
                                searchText?
                                <FontAwesomeIcon style={{color:'#7c98b6', cursor:'pointer'}} onClick={()=>setSearchText('')} icon={faClose}/>
                                :
                                <FontAwesomeIcon style={{color:'#0091ae'}} icon={faSearch}/>
                            }
                        />
                    </div>
                    }
                    <div className='filter-item' style={{marginLeft:2}} ref={popoverRef}>
                        <Popover
                            open={customerPopover}
                            afterOpenChange={()=>{inputRef.current.focus()}}
                            overlayClassName='settingCustomPopover'
                            content={
                                <div ref={popoverRef} style={{width:'500px'}}>
                                    <div className="popover-search">
                                        <Input type="search" 
                                            name="popoverSearch"
                                            ref={inputRef}
                                            style={{ width: '-webkit-fill-available', backgroundColor: 'white'  }} 
                                            className='generic-input-control' 
                                            placeholder="Search Customer..."
                                            autoFocus
                                            value={customerSearch}
                                            onChange={(e)=>{setCustomerSearch(e.target.value)}}
                                            autoComplete="off"
                                            suffix={<FontAwesomeIcon style={{color:'#0091ae'}}  icon={faSearch}/>}
                                        />
                                    </div>

                                    <div className="popover-data" ref={popoverRef} style={{
                                        // height:'250px',
                                        overflowY:'scroll',
                                    }}>
                                        {customerSearch?.length<1 &&
                                            <div className="popoverdataitem" onClick={(e)=>{setSelectedCustomer({name: e.target.innerText, id:null}); setCustomerPopover(false)}}>
                                                All Standard Tasks
                                            </div>
                                        }
                                        
                                        {customerData?.customers?.customers?.map((customer)=>{
                                            
                                            return <div className="popoverdataitem"  onClick={(e)=>{setSelectedCustomer({name: e.target.innerText, id: customer?._id}); setCustomerPopover(false)}}> {customer?.customername}</div>
                                            
                                        })}
                                        
                                    </div>

                                </div>
                            }
                            trigger="click"
                            placement='bottom'

                            onOpenChange={(visible) => {
                                if (!visible) {
                                    setGroupPopover(false);
                                    setCustomerPopover(false);

                                }
                            }}
                        >

                            {/* {
                                selectedCustomer?
                                <div ref={popoverRef} className={true?'selectedText' : 'grid-text-btn selectedTextpadding'}
                                    onClick={(e)=>{
                                        setCustomerPopover(!customerPopover)
                                    }}
                                >
                                    <span>
                                        {selectedCustomer?.name} &nbsp;
                                        <CaretDownFilled style={{color:'#0091ae'}} />
                                    </span>
                                    <FontAwesomeIcon className="selectedTextCloseIcon" onClick={()=>{ setSelectedCustomer({name: "All Standard Tasks", id:null}) }} icon={faClose}/>
                                  
                                </div>
                                :
                                <div ref={popoverRef} className=' grid-text-btn selectedTextpadding' onClick={()=>setCustomerPopover(!customerPopover)}>
                                    {"All Standard Tasks"} &nbsp;
                                    <CaretDownFilled style={{color:'#0091ae'}} />
                                </div>
                            } */}
                        </Popover>
                    </div>
                    
                    {isLegacyTenant &&
                    <div className='filter-item' ref={popoverRef}>
                        <Popover
                            open={groupPopover}
                            overlayClassName='settingCustomPopover'
                            afterOpenChange={()=>{inputRef.current.focus();}}
                            content={
                                <div ref={popoverRef}>
                                    <div className="popover-search" ref={popoverRef}>
                                        <Input type="search" 
                                            ref={inputRef}
                                            id="inputSearch"
                                            name='popoverSearch'
                                            style={{ width: '-webkit-fill-available', backgroundColor: 'white'  }} 
                                            className='generic-input-control' 
                                            placeholder="Search..."
                                            autoFocus={groupPopover}
                                            autoComplete="off"
                                            value={groupSearch}
                                            onChange={(e)=> {
                                                setLocalGroup(groupList?.filter((group)=> (group.name)?.toLowerCase()?.includes(e.target.value?.toLowerCase())))
                                                setGroupSearch(e.target.value)
                                            }}
                                            suffix={<FontAwesomeIcon style={{color:'#0091ae'}}  icon={faSearch}/>}
                                        />
                                    </div>

                                    <div className="popover-data"  ref={popoverRef}  style={{overflow:'auto ', maxHeight:'350px'}}>
                                        {localGroup?.length ?
                                        <div 
                                            className={group=="All groups"? "popoverdataitem popoverdataitem-active": "popoverdataitem"} 
                                            onClick={(e)=>{setGroup({name:e.target.innerText, id: null}); setGroupPopover(false)}}>
                                            {"All groups"}
                                        </div>
                                        :
                                        
                                        <div 
                                            className={group=="All groups"? "popoverdataitem popoverdataitem-active": "popoverdataitem"} 
                                            onClick={(e)=>{setGroupPopover(false)}}>
                                            {"No group found"}
                                        </div>
                                        }
                                        {localGroup && localGroup?.map((gl)=>(

                                            <div 
                                                className={group==gl.name? "popoverdataitem popoverdataitem-active": "popoverdataitem"} 
                                                onClick={(e)=>{setGroup({name: e.target.innerText, id: gl._id}); setGroupPopover(false)}}>
                                                {gl.name}
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            }
                            trigger="click"
                            placement='bottom'

                            onOpenChange={(visible) => {
                                if (!visible) {
                                    setGroupPopover(false);
                                    setCustomerPopover(false);

                                }
                            }}
                        >
                            {
                                group && Object.keys(group)?.length>0 && group?.name!="All groups"?
                                <div ref={popoverRef} className={true?'selectedText' : 'grid-text-btn selectedTextpadding'}
                                    onClick={(e)=>{
                                        setGroupPopover(!groupPopover)
                                    }}
                                >
                                    <span>
                                        {group?.name} &nbsp;
                                        <CaretDownFilled style={{color:'#0091ae'}} />
                                    </span>
                                    <FontAwesomeIcon className="selectedTextCloseIcon" onClick={()=>{ 
                                        setGroup({name:"All Groups", id:0}) }} icon={faClose}
                                    />
                                  
                                </div>
                                :
                                <div ref={popoverRef} className=' grid-text-btn selectedTextpadding' onClick={()=>{setGroupPopover(!groupPopover)}}>
                                    {"All Groups"} &nbsp;
                                    <CaretDownFilled style={{color:'#0091ae'}} />
                                </div>
                            }

                            {/* <span ref={popoverRef} className='truncated-text' onClick={()=>setGroupPopover(!groupPopover)}>{group? group?.name :"All Groups"}
                                <span className='caret'></span>
                            </span> */}
                        </Popover>
                    </div>
                    }

                    


                </div>

            </div>
        </div>
    )
}